import { jsx, jsxs } from "react/jsx-runtime";
import { IconHamburger, IconClose } from "./ConciergeIcons.js";
import { ConciergeHomeMobileNavWidget, themeColor, ConciergeHomeLogoWidget } from "@brandclub/bc-widgets";
const ShareIcon = ({ size }) => /* @__PURE__ */ jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [
  /* @__PURE__ */ jsx("path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }),
  /* @__PURE__ */ jsx("polyline", { points: "16 6 12 2 8 6" }),
  /* @__PURE__ */ jsx("line", { x1: "12", y1: "2", x2: "12", y2: "15" })
] });
const ConciergeHomeMobileNav = ({
  brandLogoUrl,
  onMenuClick,
  onCloseClick,
  onShareClick
}) => {
  return /* @__PURE__ */ jsx(ConciergeHomeMobileNavWidget, { children: (state, icons, resolveColor) => {
    const bgColor = resolveColor(state.navBgColor);
    const textPrimary = themeColor("textPrimary");
    const hamburgerColor = resolveColor(textPrimary);
    const closeColor = resolveColor(textPrimary);
    return /* @__PURE__ */ jsxs(
      "nav",
      {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: state.navHeight,
          padding: `${state.navPaddingY}px ${state.navPaddingX}px`,
          boxSizing: "border-box",
          flexShrink: 0,
          ...bgColor && bgColor !== "transparent" ? { backgroundColor: bgColor } : {}
        },
        children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              onClick: onMenuClick,
              "aria-label": "Open menu",
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: state.hamburgerIconSize,
                height: state.hamburgerIconSize,
                padding: 0,
                border: "none",
                background: "none",
                cursor: "pointer",
                color: hamburgerColor || "inherit"
              },
              children: icons.hamburgerIconUrl ? /* @__PURE__ */ jsx(
                "img",
                {
                  src: icons.hamburgerIconUrl,
                  alt: "Menu",
                  style: {
                    width: state.hamburgerIconSize,
                    height: state.hamburgerIconSize,
                    objectFit: "contain"
                  }
                }
              ) : /* @__PURE__ */ jsx(IconHamburger, { size: state.hamburgerIconSize })
            }
          ),
          state.showLogo ? /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                minWidth: 0,
                padding: "0 8px"
              },
              children: /* @__PURE__ */ jsx("div", { style: { width: "100%", maxWidth: 120 }, children: /* @__PURE__ */ jsx(
                ConciergeHomeLogoWidget,
                {
                  widgetId: "concierge-home-mobile-nav-logo",
                  displayName: "Mobile Nav Logo",
                  initialState: {
                    logoWidth: 79,
                    mobile_logoWidth: 79,
                    logoMaxHeight: 18
                  },
                  logoUrl: brandLogoUrl
                }
              ) })
            }
          ) : /* @__PURE__ */ jsx("div", { style: { width: state.closeIconSize, height: state.closeIconSize } }),
          onShareClick ? /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              onClick: onShareClick,
              "aria-label": "Share conversation",
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: state.closeIconSize,
                height: state.closeIconSize,
                padding: 0,
                border: "none",
                background: "none",
                cursor: "pointer",
                color: closeColor || "inherit"
              },
              children: /* @__PURE__ */ jsx(ShareIcon, { size: 24 })
            }
          ) : /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              onClick: onCloseClick,
              "aria-label": "Close",
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: state.closeIconSize,
                height: state.closeIconSize,
                padding: 0,
                border: "none",
                background: "none",
                cursor: "pointer",
                color: closeColor || "inherit"
              },
              children: icons.closeIconUrl ? /* @__PURE__ */ jsx(
                "img",
                {
                  src: icons.closeIconUrl,
                  alt: "Close",
                  style: {
                    width: state.closeIconSize,
                    height: state.closeIconSize,
                    objectFit: "contain"
                  }
                }
              ) : /* @__PURE__ */ jsx(IconClose, { size: state.closeIconSize })
            }
          )
        ]
      }
    );
  } });
};
export {
  ConciergeHomeMobileNav
};
//# sourceMappingURL=ConciergeHomeMobileNav.js.map
